// extracted by mini-css-extract-plugin
export var errorsContainer = "_qx-1";
export var link = "_qx-0";